<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="fm01">
<div class="chapterHead">
<p class="chapterTitle"><a href="#/contents#fm_01">The Thing Before the Rest of the Thing</a></p>
</div>
<p class="x1BM-FIRST">I didn’t know what to call this part of the book. I guess you could call it a preface, but that sounds too fancy to me. I’ve already got an introduction (that comes later) and this obviously isn’t a table of contents. You might call it a foreword, but don’t <span class="ITALIC">other</span> people usually write forewords? You know, like the author’s famous friends. I’ve got some of those, but they’re usually pretty busy signing autographs and swimming in great vats of their own money, Scrooge McDuck–style.</p>
<p class="x1BM">Anyway, I want to tell you some important stuff up front, before we get to the rest of this tragicomic journey into the depths of my lady-soul. This story is mostly true. I tried my best to keep it real, as the children say, but I’m not a fucking journalist. I didn’t have a damn tape recorder on me during every conversation.</p>
<p class="x1BM">Please also keep in mind that when a lot of the stuff chronicled in this book actually happened, I was crazy as a loon. On meth. In a crack house. I had to fill in some of the fuzzier memories with my best guesses as to what actually happened.</p>
<p class="x1BM">A few of the characters represent amalgamated mishmashes of people I once knew. I changed some names, places, and identifying details for a couple of reasons. I still talk to some of the people in this book, and I’d like to keep it that way. I don’t talk to some of the others, and I’d <span class="ITALIC">really</span> like to keep it that way.</p>
<p class="x1BM">Rest assured that the grossest, meanest, ugliest, most foolish things that <span class="ITALIC">I</span> do in this story all actually happened in real life. I subscribe to the notion that if you can laugh at the shittiest moments in your life, you can transcend them. And if other people can laugh at your awful shit as well, then I guess you can officially call yourself a comedian.</p>
<p class="x1BM">That is all. Thank you. I hope you like the rest of my book. If not, feel free to use it for kindling to warm yourself in the cold night when the Revolution comes. And oh, it’s coming.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?68528389